module.exports = __webpack_public_path__ + "static/media/no_intervenant_icon.da5476ac.svg";